module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Bold.1dee9f6.ttf";